const isSwipeDetected = (touchData) => {
  const { touchendX, touchstartX, touchstartY, touchendY } = touchData;
  return Math.abs(touchendX - touchstartX) > 70 && Math.abs(touchstartY - touchendY) < 50;
};

export default isSwipeDetected;
